import "nprogress/nprogress.css";
import { lazy } from "react";

const LazyLoadFailed = () => null;

const lazyLoader = (importFunc) =>
  lazy(() =>
    importFunc().catch((err) => {
      console.error("Failed to load module:", err);
      return { default: LazyLoadFailed };
    })
  );

export default lazyLoader;
